export const OptionsMap = {
  score_desc: 'Relevância',
  orders_desc: 'Mais vendidos',
  price_asc: 'Mais barato',
  price_desc: 'Mais caro',
  discount_desc: 'Maior desconto',
}
